import { render, staticRenderFns } from "./DuplicateCharacteristics.vue?vue&type=template&id=88b79ec8&"
import script from "./DuplicateCharacteristics.vue?vue&type=script&lang=js&"
export * from "./DuplicateCharacteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports